import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface QuickAccessCardProps {
  title: string;
  description: string;
  icon: string;
  href: string;
  color: string;
}

const QuickAccessCard = ({
  title,
  description,
  icon,
  href,
  color
}: QuickAccessCardProps) => {
  return (
    <Link
      href={href}
      className="bg-white rounded-lg border border-gray-200 p-5 hover:border-blue-300 hover:shadow-md transition-all duration-300 group h-full flex flex-col"
    >
      <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center mb-3 group-hover:bg-blue-100 transition-colors duration-300">
        <Icon name={icon as any} size={24} variant="outline" className="text-blue-600" />
      </div>
      
      <h3 className="text-base font-semibold text-gray-900 mb-2 leading-tight">
        {title}
      </h3>
      <p className="text-sm text-gray-600 leading-snug flex-grow">
        {description}
      </p>
    </Link>
  );
};

export default QuickAccessCard;